const checkRelease = () => {
}
checkRelease.output='2023-03-22';
export default checkRelease;